import { useEffect, useRef } from "react";
import { useTranslation } from 'react-i18next';
import CloseIcon from '../../images/close_icon.png';
import QRIcon from '../../images/qr-code_icon.png';
import InAppCheck from '../../images/InAppCheck.png';
import InAppCross from '../../images/InAppCross.png';
import HistoryIcon from '../../images/history_icon.png';
import { callIfMouseSupported, callIfTouchSupported, callIfPointerSupported } from '../General/EventSupport';
import './MoreOptionsPopup.less';

const MoreOptionsPopup = ({
  showAllOptions = false,
  allFilesNotInApp = false,
  allFilesInApp = false,
  filterActive = false,
  onClickCloseButton = () => {},
  onClickFirstButton = () => {},
  onClickSecondButton = () => {},
  onClickThirdButton = () => {},
  onClickFourthButton = () => {},
  open = false,
}) => {
  const { t } = useTranslation();
  const popupRef = useRef(null);
  const handlePointerClickOutside = (e) =>{
    callIfPointerSupported(handleClickOutside(e), e)
  };
  const handleMouseClickOutside = (e) => {
    callIfMouseSupported(handleClickOutside(e), e)
  };
  const handleTouchOutside = (e) => {
    callIfTouchSupported(handleClickOutside(e))
  };
  const handleClickOutside = (event) => {
      if (open && popupRef.current && !popupRef.current.contains(event.target)) {
        onClickCloseButton(event);
      }
  }

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    document.addEventListener("pointerup", handlePointerClickOutside);
    document.addEventListener("mouseup", handleMouseClickOutside);
    document.addEventListener("touchstart", handleTouchOutside);

    return () => {
      document.removeEventListener("pointerup", handlePointerClickOutside);
      document.removeEventListener("mouseup", handleMouseClickOutside);
      document.removeEventListener("touchstart", handleTouchOutside);
    };
  }, [onClickCloseButton]);
  /* eslint-enable react-hooks/exhaustive-deps */
  if (!open) return null;

  const stopEvent = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <div
      className="more_options_popup"
      onClick={stopEvent}
      ref={popupRef}
    >
      <div className="more_options_header">
        <label className="more_options_title">{t('MoreOptions')}</label>
        <button
          title={t('Close')}
          className="close_button"
          onPointerUp={(e) => callIfPointerSupported(() => onClickCloseButton(e), e)}
          onTouchStart={(e) => callIfTouchSupported(() => onClickCloseButton(e))}
          onMouseUp={(e) => callIfMouseSupported(() => onClickCloseButton(e), e)}
        >
          <img src={CloseIcon} alt={t('Close')} />
        </button>
      </div>
      <div className="more_options_body">
        <div className="button_column">
          <button
            onPointerUp={(e) => callIfPointerSupported(() => {onClickFirstButton(e); onClickCloseButton(e)}, e)}
            onTouchStart={(e) => callIfTouchSupported(() => {onClickFirstButton(e); onClickCloseButton(e)})}
            onMouseUp={(e) => callIfMouseSupported(() => {onClickFirstButton(e); onClickCloseButton(e)}, e)}
            title={t('ViewModelList')}
            className="armodelviewer_button"
            id="view_modellist_button"
          >
            <div className="img_container">
              <img src={QRIcon} className="qr_code_img" alt={t('QRCode')} />
            </div>
            {t('ViewModelList')}
          </button>

          {showAllOptions && (
            <button
              title={filterActive ? t('SelectedModelsInAppHover') : t('AllModelsInAppHover')}
              disabled={allFilesInApp}
              id="all_in_app_button"
              className="armodelviewer_button"
              onPointerUp={(e) => callIfPointerSupported(() => {onClickSecondButton(e); onClickCloseButton(e)}, e)}
              onTouchStart={(e) => callIfTouchSupported(() => {onClickSecondButton(e); onClickCloseButton(e)})}
              onMouseUp={(e) => callIfMouseSupported(() => {onClickSecondButton(e); onClickCloseButton(e)}, e)}
            >
              <div className="img_container">
                <img src={InAppCheck} className="checkmark_img" alt={t('Checkmark')} />
              </div>
              {filterActive ? t('SelectedModelsInApp') : t('AllModelsInApp')}
            </button>
          )}

          {showAllOptions && (
            <button
              title={filterActive ? t('SelectedModelsOutAppHover') : t('AllModelsOutAppHover')}
              disabled={allFilesNotInApp}
              id="none_in_app_button"
              className="armodelviewer_button"
              onPointerUp={(e) => callIfPointerSupported(() => {onClickThirdButton(e); onClickCloseButton(e)}, e)}
              onTouchStart={(e) => callIfTouchSupported(() => {onClickThirdButton(e); onClickCloseButton(e)})}
              onMouseUp={(e) => callIfMouseSupported(() => {onClickThirdButton(e); onClickCloseButton(e)}, e)}
            >
              <div className="img_container">
                <img src={InAppCross} className="checkmark_x_img" alt={t('Checkmark')} />
              </div>
              {filterActive ? t('SelectedModelsOutApp') : t('AllModelsOutApp')}
            </button>
          )}

          {showAllOptions && (
            <button
              title={t('JobHistory')}
              id="job_history_button"
              className="armodelviewer_button"
              onPointerUp={(e) => callIfPointerSupported(() => {onClickFourthButton(e); onClickCloseButton(e)}, e)}
              onTouchStart={(e) => callIfTouchSupported(() => {onClickFourthButton(e); onClickCloseButton(e)})}
              onMouseUp={(e) => callIfMouseSupported(() => {onClickFourthButton(e); onClickCloseButton(e)}, e)}
            >
              <div className="img_container">
                <img src={HistoryIcon} className="job_history_img" alt={t('JobHistory')}/>
              </div>
              {t('JobHistory')}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default MoreOptionsPopup;
